import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnRU: CultureInfo = {
  name: 'en-RU',
  displayName: 'English (Russia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-RU',
  parent: CultureInfoEn
};
